import React from "react";
import { CgCloseO } from "react-icons/cg";
import Modal from "react-modal";

const getCustomStyles = (width = "30%", isSidebar = false) => ({
    content: isSidebar ?
        {
            top: "0%",
            right: "0%",
            left: "auto",
            bottom: "auto",
            width: width,
            maxWidth: "100%",
            zIndex: 1050,
            padding: "20px",
            height: "100%",
            animation: "slideInFromRight 0.3s ease-out forwards",
        } : {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: width,
            maxWidth: "100%",
            zIndex: 1050,
            padding: "20px",
            animation: "fadeInScale 0.3s ease-out forwards",
        },
    overlay: {
        zIndex: 1040,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        animation: "fadeInOverlay 0.3s ease-out forwards",
    },
});

// Add CSS animations
const modalStyles = `
    @keyframes slideInFromRight {
        from {
            transform: translateX(100%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }
    
    @keyframes fadeInScale {
        from {
            transform: translate(-50%, -50%) scale(0.8);
            opacity: 0;
        }
        to {
            transform: translate(-50%, -50%) scale(1);
            opacity: 1;
        }
    }
    
    @keyframes fadeInOverlay {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

// Inject styles into the document head
if (typeof document !== 'undefined' && !document.getElementById('modal-animations')) {
    const style = document.createElement('style');
    style.id = 'modal-animations';
    style.textContent = modalStyles;
    document.head.appendChild(style);
}

Modal.setAppElement("#root");

const ShowModal = ({
    isOpen,
    onRequestClose,
    contentLabel,
    componentToPass,
    modalWidth,
    isSidebar,
    show,
    onClose,
    title,
    size = "md",
    sidebar = false,
    children
}) => {
    // Handle both old and new prop names for backward compatibility
    const isModalOpen = isOpen || show;
    const handleClose = onRequestClose || onClose;
    const modalSize = modalWidth ?? (size === "lg" ? "50%" : size === "md" ? "40%" : "30%");
    const isSidebarMode = isSidebar || sidebar;

    return (
        <Modal
            isOpen={isModalOpen}
            onRequestClose={handleClose}
            style={getCustomStyles(modalSize, isSidebarMode)}
            contentLabel={contentLabel || title}
            closeTimeoutMS={150}
        >
            <div className="w-full h-full flex flex-col">
                {/* Header */}
                <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-200">
                    <h2 className="text-xl font-semibold text-gray-800">
                        {title || contentLabel}
                    </h2>
                    <button
                        onClick={handleClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        <CgCloseO size={24} />
                    </button>
                </div>

                {/* Content */}
                <div className="flex-1 overflow-y-auto">
                    {componentToPass || children}
                </div>
            </div>
        </Modal>
    );
};

export default ShowModal;